var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
  'presentation-set-title',
  `presentation-set-title_scale-${ _vm.$easyscreenScale }`,
  _vm.orientation
]},[_vm._v(" "+_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }